import { render } from "./TabbedContent.vue?vue&type=template&id=17bc6971"
import script from "./TabbedContent.vue?vue&type=script&lang=js"
export * from "./TabbedContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__